import { FinText } from '../../i18n';
import { Component, h } from 'preact';
import { withText } from 'preact-i18n';
import * as appStyles from '../../assets/global.scss';
import Icon from '../../common/Icon/Icon';
import { Location, Properties, Key, getKey } from '../../common';
import { Actions, actions, BookingState, connectStore } from '../../store';
import { withStyles, WithStyles } from '../../style';
import { stopPropagation } from '../../utils';

export interface LocationSwitcherProps extends Properties {}

interface TranslationProps {
  ariaLabel: string;
}

interface StoreProps {
  origin: Location;
  destination: Location;
}

const mapStateToProps = ({ selection: { locations, activeLocationIndex } }: BookingState): StoreProps => ({
  origin: locations[activeLocationIndex]?.origin,
  destination: locations[activeLocationIndex]?.destination,
});

type EffectiveProps = LocationSwitcherProps & WithStyles & TranslationProps & StoreProps & Actions;

@withStyles(appStyles)
@connectStore({ mapStateToProps, actions })
@withText({ ariaLabel: <FinText id="locationSwitcher.ariaLabel" /> })
export default class LocationSwitcher extends Component<LocationSwitcherProps> {
  switchTravelLocations = (): void => {
    const { origin, destination, setLocations } = this.props as EffectiveProps;
    setLocations({ origin: destination, destination: origin });
  };

  handleKeyPress = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      stopPropagation(e);
      this.switchTravelLocations();
    }
  };

  render({ ariaLabel, tx }: EffectiveProps): h.JSX.Element {
    return (
      <div
        class={tx(this.props.class, 'cursor-pointer', 'flex flex--center')}
        onClick={this.switchTravelLocations}
        onKeyPress={this.handleKeyPress}
        tabIndex={0}
        role="button"
        aria-label={ariaLabel}
      >
        <Icon class={tx('is-small')} iconName="switch-flights" />
      </div>
    );
  }
}
